export enum Language {
	FR = 'fr',
	EN = 'en',
	CZE = 'cze',
	DE = 'de',
	SPA = 'sp',
	PT = 'pt',
	ITA = 'ita'
}
